import { useQuery } from "@tanstack/react-query";
import { createFileRoute, useParams } from "@tanstack/react-router";
import { useMemo } from "react";
import { SearchableRolePermissionsList } from "@/features/organization-roles/SearchableRolePermissionsList";
import { organizationQueryOptions } from "@/services/organization";

export const Route = createFileRoute(
	"/_authenticated/(admin-app)/_admin/admin/roles/(roles)/$roleId/permissions",
)({
	component: RouteComponent,
});

function RouteComponent() {
	const params = useParams({
		from: "/_authenticated/(admin-app)/_admin/admin/roles/(roles)/$roleId/permissions",
	});

	const roleNameFromUrl = decodeURIComponent(params.roleId);

	const {
		data: globalRoles = [],
		isLoading,
		isError: hasError,
	} = useQuery(organizationQueryOptions.globalRoles.list());

	const role = useMemo(
		() => globalRoles.find((r) => r.name === roleNameFromUrl),
		[globalRoles, roleNameFromUrl],
	);

	return (
		<SearchableRolePermissionsList
			permissions={role?.permissions ?? []}
			isLoading={isLoading}
			hasError={hasError}
			isAdminRole={role?.adminRole}
		/>
	);
}
